import React from 'react';
import { graphql } from 'react-relay';

import PrivateHireQuickEstimatesForm from '@zego/flows/quickEstimates/privateHire/forms/PrivateHireQuickEstimatesForm';
import withData from '@zego/lib/withData';
import { BREAKPOINTS, errorColor, unit, unitTRBL, white } from '@zego/theme';
import { TrackingScope } from '@zego/tracking';

import H3 from '@zego/components/atoms/H3';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import UberPromotionBanner from '@zego/components/header/UberPromotionBanner';
import withFeatureFlags from '@zego/components/withFeatureFlags';

import UberPageWrapper from './partners/UberPageWrapper';
import PromotionsLayout from './PromotionsLayout';

import ogImage from '@zego/static/images/social/social-uber.jpg';

const GetOnTheRoadUber = ({ viewer }) => (
  <PromotionsLayout viewer={viewer} title="Zego & Uber" ogImage={ogImage}>
    <UberPageWrapper banner={<UberPromotionBanner />}>
      <TrackingScope locationName="Uber Landing Page">
        <View
          id="uber-landing-qq"
          css={{
            backgroundColor: white,
            padding: unitTRBL(3.5, 2.5, 1.75, 2.5),
            marginLeft: '-22px',
            marginRight: '-22px',
            [BREAKPOINTS.medium]: {
              marginLeft: 0,
              marginRight: 0,
            },
          }}
        >
          <div css={{ position: 'relative' }}>
            <View
              css={{
                position: 'absolute',
                zIndex: 100,
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: errorColor(3),
                borderRadius: 0,
                height: 44,
                width: 118,
                right: '-20px',
                top: '-78px',
                padding: '25px 65px 25px 65px',
                [BREAKPOINTS.normal]: {
                  padding: '60px 60px 60px 60px',
                  borderRadius: '75px',
                  right: '-60px',
                  top: '-70px',
                },
              }}
            >
              <RegularText
                css={{
                  color: white,
                  textAlign: 'center',
                  lineHeight: '14px',
                  letterSpacing: '0.4px',
                  fontSize: '17px',
                  fontWeight: 'bold',
                }}
              >
                From £173/month<sup>*</sup>
              </RegularText>
            </View>
          </div>
          <H3
            css={{
              fontSize: 18.5,
              [BREAKPOINTS.small]: { fontSize: 18.5 },
            }}
          >
            Get your quick quote now!
          </H3>
          <Spacer height={unit(2)} />
          <PrivateHireQuickEstimatesForm viewer={viewer} />
        </View>
      </TrackingScope>
    </UberPageWrapper>
  </PromotionsLayout>
);

export default withData(withFeatureFlags(GetOnTheRoadUber), {
  getVariables: ({ query }) => {
    return {
      country: query.country,
    };
  },
  query: graphql`
    query GetOnTheRoadUberQuery {
      viewer {
        ...PromotionsLayout_viewer
        ...PrivateHireQuickEstimatesForm_viewer
      }
    }
  `,
});
